"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransportMessage = exports.TRANSPORT = exports.TRANSPORT_EVENT = void 0;
const errors_1 = require("../constants/errors");
exports.TRANSPORT_EVENT = 'TRANSPORT_EVENT';
exports.TRANSPORT = {
    START: 'transport-start',
    ERROR: 'transport-error',
    UPDATE: 'transport-update',
    STREAM: 'transport-stream',
    REQUEST_DEVICE: 'transport-request_device',
    DISABLE_WEBUSB: 'transport-disable_webusb',
    START_PENDING: 'transport-start_pending',
};
const createTransportMessage = (type, payload) => ({
    event: exports.TRANSPORT_EVENT,
    type,
    payload: 'error' in payload ? (0, errors_1.serializeError)(payload) : payload,
});
exports.createTransportMessage = createTransportMessage;
//# sourceMappingURL=transport.js.map